var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"promotion-active-badge"},[_vm._v("Promotion Active")])
}
var staticRenderFns = []

export { render, staticRenderFns }